export const config = {
    STAGE: process.env.STAGE || "",
    AUTHORIZATION_HEADER: process.env.AUTHORIZATION_HEADER || "X-Authorization",
    FRONTEND_URL: process.env.NEXT_PUBLIC_FRONTEND_URL || "",
    WEB_FRONTEND_URL: process.env.NEXT_PUBLIC_WEB_FRONTEND_URL || "",
};
